import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import {
    IChecklist2ForReport,
    IChecklist2ReportAnswer,
} from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { FiChecklist2ReportHelperService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-helper.service';
import { FiChecklist2ReportDialogsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-dialogs.service';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import {
    FiTooltipButtonIconColors,
    FiTooltipIconClassType,
} from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.component';
import { IReportChartData } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart';

@Component({
    selector: 'fi-open-checklist-deviations-chart',
    template: `
        <mat-card class="checklist-report-widget-card deviations-checklists" [ngClass]="cardClass">
            <p class="deviations-checklist-heading">
                {{ 'checklist.report_deviations_checklist_description' | fiAppText }}
            </p>
            <div class="checklist-report-chart-wrapper">
                <fi-report-pie-chart
                    [isChartInteractive]="true"
                    [isSingleAlwaysFilled]="true"
                    [reportChartData]="getDeviationsChartData()"
                    (onChartClick)="openDeviationsListDialog()"
                />
            </div>
            <div class="checklist-report-chart-history">
                <div class="checklist-report-chart-history-item">
                    <div class="indicator deviations"></div>
                    <span class="checklist_report_chart_history_label">{{
                        'checklist.report_open_checklist_current_deviations' | fiAppText
                    }}</span>
                    <span class="checklist_report_chart_history_value">
                        {{ filteredNotOkAnswerDetails?.length }}
                        <fi-icon-tooltip-button
                            [isIconVisible]="true"
                            iconClass="fa-circle-info"
                            [iconClassType]="FiTooltipIconClassType.Regular"
                            [iconHoverColor]="FiTooltipButtonIconColors.Default"
                            tooltipClass="fi-rounded-white-tooltip"
                            [tooltipText]="
                                'checklist.report_open_checklist_current_deviations_tooltip_text' | fiAppText
                            "
                        />
                    </span>
                </div>
            </div>
        </mat-card>
    `,
    styleUrl: './open-checklist-deviations-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-open-checklist-deviations-chart' },
    standalone: false,
})
export class FiOpenChecklistsDeviationsChart {
    @Input() cardClass: string = '';
    @Input() filteredNotOkAnswerDetails: IChecklist2ReportAnswer[] = [];
    @Input() checklists: IChecklist2ForReport[];

    constructor(
        private fiChecklist2ReportHelperService: FiChecklist2ReportHelperService,
        private fiChecklist2ReportDialogsService: FiChecklist2ReportDialogsService,
    ) {}

    getDeviationsChartData(): IReportChartData[] {
        return this.fiChecklist2ReportHelperService.getDeviationsChartData(this.filteredNotOkAnswerDetails.length);
    }

    openDeviationsListDialog() {
        this.fiChecklist2ReportDialogsService.showOpenChecklistsDeviationsListDialog(
            this.filteredNotOkAnswerDetails,
            this.checklists,
        );
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
    protected readonly FiTooltipIconClassType = FiTooltipIconClassType;
    protected readonly FiTooltipButtonIconColors = FiTooltipButtonIconColors;
}
